import { forEach } from "../../../framework/utils/collection";
import { ComponentModel, compressComponentSource, getIndentationCount, IComponentSource, MarkdownComponent, orderedListPattern, peek, unorderedListPattern } from "./core";
import { applyTextDecoration } from "./text-decoration";

export enum ListType {
  Root,
  Number,
  BulletSolid,
  BulletOutline,
}

export interface IListGroup {
  itemsType: ListType;
  items: IListItem[];
}
export interface IListItem {
  itemType: ListType;
  indentCount: number;
  text: string;
  groups: IListGroup[];
}

export interface IListComponentModel extends IComponentSource, IListItem {}

class ListComponentModel extends ComponentModel implements IListComponentModel {
  public itemType: ListType = ListType.Root;
  public indentCount: number = 0;
  public text: string = '';
  public groups: IListGroup[] = [];
}

const getListItemType = (lineType: MarkdownComponent, parentItemType: ListType): ListType => {
  if(lineType === MarkdownComponent.OrderedList || lineType === MarkdownComponent.OrderedListFragment) { return ListType.Number; }
  const t = parentItemType === ListType.Number || parentItemType === ListType.BulletSolid ?
    ListType.BulletOutline : ListType.BulletSolid;

  return t;
}

export const buildListComponentModel = (source: IComponentSource) => {
  compressComponentSource(source, true);
  const listComponent = new ListComponentModel(source);
  const stack: IListItem[] = [ listComponent ];

  forEach(source.content, line => {
    const indentCount = getIndentationCount(line.content);
    while((peek(stack)?.indentCount ?? 0) >= indentCount) {
      stack.pop();
    }

    const parent = peek(stack)!;
    const prefix = (line.type === MarkdownComponent.OrderedList || line.type === MarkdownComponent.OrderedListFragment) ? orderedListPattern : unorderedListPattern;
    const text = applyTextDecoration(source.type, line.content.replace(prefix, ''));
    const item: IListItem = {
      itemType: getListItemType(line.type, parent.itemType),
      indentCount,
      text,
      groups: []
    };

    if(parent.groups.length === 0 || peek(parent.groups)!.itemsType !== item.itemType) {
      parent.groups.push({
        itemsType: item.itemType,
        items: [ item ]
      });
    } else {
      peek(parent.groups)!.items.push(item);
    }

    stack.push(item);
  });

  return listComponent;
}